<script setup>
import { ref, onMounted, watch} from 'vue'
import DropDown from "@/components/common/DropDownSelect.vue"

//properties set by parent
const props = defineProps({
	indicator: {
		type: Object,
		required: true,
	},
	categories: {
		type: Array,
		required: true
	},	
	chartSettings: {
		type: Object,
		required: true
	}	
}) 

//componenet methods exposed to parent


//events raised by component
const emit = defineEmits(["openFilters","updateCategory"])


//reactive field proxies
const cats = ref([])

//local variables

// Use a local copy to avoid mutating props directly
const selectedCategoryName = ref('')


function setupFilters() {
	emit('openFilters');
}

function updateCategory(catName) {
	//revert old selected category selections to false except for ALL SET TO TRUE
	//let chartSettings = {...props.chartSettings}
	let chartSettings = props.chartSettings

	//find new selected category
	let seriesDim = cats.value.find(i => i.columnName == catName)	
	selectedCategoryName.value = catName
 	//for new cat, set selections to true for all values except ALL
 	let allVal = seriesDim.totalLabel
	let found = seriesDim.appliedValues.findIndex(i => i.name == allVal)
	seriesDim.appliedValues.forEach((i, x) => {
		if(allVal == null && found == -1) {
			//if no All then select 1st as default
			i.selected = x==0?true:false; 
		} else if(i.name == allVal)
			i.selected = false
		else
			i.selected = true
	})

	chartSettings.seriesDim = seriesDim
	emit('updateCategory', chartSettings);
}

onMounted(() => {
	if(props.chartSettings && props.chartSettings.xAxisDim && props.chartSettings.seriesDim) {
		selectedCategoryName.value = props.chartSettings.seriesDim.columnName
		cats.value = props.categories.filter(cat => {
			if(cat.categoryLabelFlag == 1 && (cat.childColumnName == null)) {
				if(cat.columnName !== props.chartSettings.xAxisDim.columnName) {
					return cat
				}
			}
		})	
	}

 	// watch(selectedCategoryName, (newValue, oldValue) => {
	// 	if(newValue != oldValue && oldValue != "") {
	// 		updateCategory()
	// 	}
	// })

 	watch(props, (newValue) => {
		selectedCategoryName.value = newValue.chartSettings.seriesDim.columnName
		cats.value = newValue.categories.filter(cat => {
			if(cat.categoryLabelFlag == 1 && (cat.childColumnName == null)) {
				if(cat.columnName !== props.chartSettings.xAxisDim.columnName) {
					return cat
				}
			}
		})
	})

}); 

</script>

<template>
	<div class="chart-options">
		<div class="chart-options-row">
			<div class="chart-options-col">
				<div>
					<div class="label-text">Categories</div>
				</div>
				<div>
					<DropDown v-model="selectedCategoryName" :list="cats" :keyField="'columnName'" @selectedDropdown="updateCategory"  />
				</div>
			</div>
			<div class="chart-options-col bottom">
				<button @click="setupFilters" class="btn-tertiary"><span class="icon-settings">
				<i class="fa-regular fa-sliders"></i></span>Customize chart</button>
			</div>			
		</div>
	</div>	
</template>

<style scoped>
.chart-options {
	margin: 0 1.25rem 0.25rem 1.25rem;	
}

.chart-options-row {
	display: flex;
	justify-content: start;
	column-gap: var(--spacing-lg);
}

.chart-options-col {
	display: flex;
	flex-direction: column;
	justify-content: start;
}

.chart-options-col.bottom {
	justify-content: end;
	width: 100%;
}

.label-text {
	color: var(--text-Secondary);
	font-family: var(--font-family-Title);
	font-weight: var(--font-weight-Medium);
	font-size: var(--font-size-Base);
}

.btn-tertiary {
	padding: 0 0.25rem;
	height: 2.5rem;
	white-space: nowrap;
	width: fit-content;
}

.drop-down {
	padding-left: 0;
}

.icon-settings {
	color: var(--icon-cta-Blue);
	margin-right:.5rem;
}

/* 780px - Max container size when Settings panel displayed */
/* .chart-options {
	container-type: inline-size;
}
@container (max-width: 50.3125rem) {
	.chart-options-row {
		flex-wrap: wrap;
	}
} */

/* 767px - mobile */
@media (max-width: 47.9375rem) {
	.chart-options-row {
		flex-wrap: wrap;
	}	

	.chart-options-col {
		flex: 1 1 100%;
		padding-top: 1rem;
	}

	.chart-options-col.bottom {
		justify-content: start;
		margin-right: 0;
		margin-bottom:.5rem;
	}
}
</style>